import React, { memo } from 'react';
import Benefit from './benefit';
import Container from '../../atoms/Container';
import Header from '../../atoms/Header';
import { Content, ButtonWrapper, StyledButton, ButtonGroupText, Legal, } from './components';
import { eventParamAttributes, } from '@spotify-internal/touchdown-analytics';
import { purify } from '../../utils/helpers';
export function Benefits({ header, benefits = [], legalDisclaimers = [], buttons = [], buttonGroupText, container, size, eventParams, }) {
    const hasImages = buttons ? buttons.every(({ image }) => image) : false;
    return (React.createElement(Container, Object.assign({}, eventParamAttributes(eventParams), container),
        header && React.createElement(Header, Object.assign({}, header)),
        React.createElement(Content, null, benefits.map((benefit, i) => (React.createElement(Benefit, Object.assign({ key: `benefit-${i}` }, benefit, { size: size }))))),
        !!buttons.length && (React.createElement(ButtonWrapper, { hasImages: hasImages },
            buttonGroupText && (React.createElement(ButtonGroupText, { dangerouslySetInnerHTML: { __html: purify(buttonGroupText) } })),
            buttons.map((button, i) => (React.createElement(StyledButton, Object.assign({ key: `benefits-button-${i}` }, button)))))),
        legalDisclaimers.map((legalDisclaimer, i) => (React.createElement(Legal, { key: `legal-${i}`, dangerouslySetInnerHTML: { __html: purify(legalDisclaimer) } })))));
}
export default memo(Benefits);
//# sourceMappingURL=benefits.js.map